import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/terms/")({
  head: () => routeHead("/terms/"),
  beforeLoad: () => {
    throw redirect({ href: "/termeni-si-conditii", statusCode: 301, replace: true });
  },
});
